import {
  HubConnectionBuilder,
  HubConnectionState,
  LogLevel,
} from "@microsoft/signalr";
import Store from "@/store";

// Same-origin in produzione (client servito da Chazuke.Web.Api), API locale in dev
const baseURL =
  process.env.NODE_ENV === "development" ? "http://localhost:8000" : "";
const HUB_URL = `${baseURL}/hubs/dsr-notifications`;
const HEARTBEAT_INTERVAL_MS = 30000;

let connection = null;
let heartbeatTimer = null;

function setStatus(status) {
  Store.dispatch("notifications/setConnectionStatus", status);
}

function startHeartbeat() {
  stopHeartbeat();
  heartbeatTimer = setInterval(() => {
    if (connection?.state === HubConnectionState.Connected) {
      connection.invoke("Heartbeat").catch(() => {
        // Keep-alive best-effort: la riconnessione è gestita da withAutomaticReconnect
      });
    }
  }, HEARTBEAT_INTERVAL_MS);
}

function stopHeartbeat() {
  if (heartbeatTimer) {
    clearInterval(heartbeatTimer);
    heartbeatTimer = null;
  }
}

export async function start() {
  if (connection) return;

  connection = new HubConnectionBuilder()
    .withUrl(HUB_URL, {
      accessTokenFactory: () => Store.state.user.userToken,
    })
    .withAutomaticReconnect([0, 2000, 10000, 30000])
    .configureLogging(LogLevel.Warning)
    .build();

  // Il nome del metodo SignalR deriva dal nome del valore di DsrNotificationType: un listener
  // per tipo, entrambi verso lo stesso ingresso nello store.
  connection.on("DocumentRetrievalFailed", (payload) => {
    Store.dispatch("notifications/onIncoming", payload);
  });

  connection.on("DocumentYearMismatch", (payload) => {
    Store.dispatch("notifications/onIncoming", payload);
  });

  connection.onreconnecting(() => setStatus("connecting"));
  connection.onreconnected(() => setStatus("connected"));
  connection.onclose(() => setStatus("disconnected"));

  setStatus("connecting");
  try {
    await connection.start();
    setStatus("connected");
    startHeartbeat();
  } catch (err) {
    console.error("SignalR connection failed", err);
    setStatus("disconnected");
    connection = null;
  }
}

export async function stop() {
  stopHeartbeat();
  if (!connection) return;
  const current = connection;
  connection = null;
  try {
    await current.stop();
  } catch (err) {
    console.error("SignalR disconnection failed", err);
  }
  setStatus("disconnected");
}
